"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_MEETING_URL = exports.COACH_REVIEW_URL = exports.COACH_URL = exports.REDEMPTION_ENTRY_URL = exports.REWARDS_URL = exports.OPPORTUNITIES_URL = exports.OFFERS_URL = exports.CREDIT_LINKAGE_URL = exports.SETTINGS_ACCOUNTS_URL = exports.SETTINGS_URL = exports.CREDIT_URL = exports.NETWORTH_URL = exports.ASSETS_URL = exports.DEBTS_URL = exports.LINKED_ACCOUNTS_URL = exports.INCOME_URL = exports.SPENDING_URL = exports.TRANSACTIONS_URL = exports.INSIGHTS_URL = exports.FUTURE_URL = exports.DASHBOARD_URL = exports.FEED_TAG_PUBLIC_URL = exports.FEED_TAG_URL = exports.FEED_AUTHOR_PUBLIC_URL = exports.FEED_AUTHOR_URL = exports.FEED_POST_PUBLIC_URL = exports.FEED_POST_URL = exports.FEED_TAGS_BASE_URL = exports.FEED_AUTHORS_BASE_URL = exports.FEED_POSTS_BASE_URL = exports.FEED_POSTS_URL = exports.INTERNAL_ENTRY_URL = exports.EXTERNAL_DASHBOARD_URL = exports.PASSWORD_RESET_URL = exports.LOGOUT_URL = exports.LOGIN_URL = exports.FAQ_URL = exports.PRIVACY_POLICY_URL = exports.TERMS_CONDITIONS_URL = exports.SECURITY_URL = exports.PRESS_URL = exports.ABOUT_URL = exports.HOMEPAGE_URL = exports.ONBOARDING_SUMMARY_URL = exports.ONBOARDING_ACCOUNTS_URL = exports.ONBOARDING_CREDIT_URL = exports.ONBOARDING_PROPERTY_URL = exports.ONBOARDING_REGISTER_URL = exports.ONBOARDING_ENTRY_URL = exports.SITE_URL = void 0;
exports.STYLEGUIDE_URL = exports.SG_WORKSPACE_URL = exports.SG_THEMES_URL = exports.SG_LAYOUTS_URL = exports.SG_ORGANISMS_URL = exports.SG_MOLECULES_URL = exports.SG_ATOMS_URL = exports.SG_META_URL = exports.CREDIT_CARD_URL = void 0;
exports.SITE_URL = 'https://statusmoney.com';
exports.ONBOARDING_ENTRY_URL = '/onboarding';
exports.ONBOARDING_REGISTER_URL = '/onboarding/register';
exports.ONBOARDING_PROPERTY_URL = '/onboarding/property';
exports.ONBOARDING_CREDIT_URL = '/onboarding/credit';
exports.ONBOARDING_ACCOUNTS_URL = '/onboarding/accounts';
exports.ONBOARDING_SUMMARY_URL = '/onboarding/summary';
exports.HOMEPAGE_URL = '/';
exports.ABOUT_URL = '/about';
exports.PRESS_URL = '/press';
exports.SECURITY_URL = '/security';
exports.TERMS_CONDITIONS_URL = '/terms';
exports.PRIVACY_POLICY_URL = '/privacy';
exports.FAQ_URL = '/faq';
exports.LOGIN_URL = '/login';
exports.LOGOUT_URL = '/logout';
exports.PASSWORD_RESET_URL = '/password-reset';
exports.EXTERNAL_DASHBOARD_URL = '/economic-data';
exports.INTERNAL_ENTRY_URL = '/internal-entry';
exports.FEED_POSTS_URL = '/feed';
exports.FEED_POSTS_BASE_URL = '/feed/posts';
exports.FEED_AUTHORS_BASE_URL = '/feed/users';
exports.FEED_TAGS_BASE_URL = '/feed/tags';
exports.FEED_POST_URL = exports.FEED_POSTS_BASE_URL + '/:postUid';
exports.FEED_POST_PUBLIC_URL = exports.FEED_POST_URL + '/public';
exports.FEED_AUTHOR_URL = exports.FEED_AUTHORS_BASE_URL + '/:authorName';
exports.FEED_AUTHOR_PUBLIC_URL = exports.FEED_AUTHOR_URL + '/public';
exports.FEED_TAG_URL = exports.FEED_TAGS_BASE_URL + '/:tagName';
exports.FEED_TAG_PUBLIC_URL = exports.FEED_TAG_URL + '/public';
exports.DASHBOARD_URL = '/dashboard';
exports.FUTURE_URL = '/future';
exports.INSIGHTS_URL = '/insights';
exports.TRANSACTIONS_URL = '/transactions';
exports.SPENDING_URL = '/spending';
exports.INCOME_URL = '/income';
exports.LINKED_ACCOUNTS_URL = '/linked-accounts';
exports.DEBTS_URL = '/debts';
exports.ASSETS_URL = '/assets';
exports.NETWORTH_URL = '/net-worth';
exports.CREDIT_URL = '/credit';
exports.SETTINGS_URL = '/settings';
exports.SETTINGS_ACCOUNTS_URL = '/settings/accounts';
exports.CREDIT_LINKAGE_URL = '/credit-linkage';
exports.OFFERS_URL = '/offers';
exports.OPPORTUNITIES_URL = '/opportunities';
exports.REWARDS_URL = '/rewards';
exports.REDEMPTION_ENTRY_URL = '/redemption';
exports.COACH_URL = '/coaching';
exports.COACH_REVIEW_URL = `${exports.COACH_URL}/review`;
exports.VIDEO_MEETING_URL = `/video`;
exports.CREDIT_CARD_URL = `/card`;
// Styleguide
exports.SG_META_URL = '/styleguide/meta';
exports.SG_ATOMS_URL = '/styleguide/atoms';
exports.SG_MOLECULES_URL = '/styleguide/molecules';
exports.SG_ORGANISMS_URL = '/styleguide/organisms';
exports.SG_LAYOUTS_URL = '/styleguide/layouts';
exports.SG_THEMES_URL = '/styleguide/themes';
exports.SG_WORKSPACE_URL = '/styleguide/workspace';
exports.STYLEGUIDE_URL = '/styleguide';
